if (!customElements.get('b2b-room-browser')) {
  customElements.define('b2b-room-browser', class extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[data-room-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-room-panel]'));
      this.tablist = this.querySelector('[role="tablist"]');
      if (!this.tabs.length || !this.tablist) return;
      this.mobile = window.matchMedia('(max-width: 749px)');
      this.onOrientation = () => this.tablist.setAttribute('aria-orientation', this.mobile.matches ? 'horizontal' : 'vertical');
      this.onClick = event => {
        const tab = event.target.closest('[data-room-tab]');
        if (tab && this.contains(tab)) this.select(this.tabs.indexOf(tab));
      };
      this.onKeydown = event => {
        const index = this.tabs.indexOf(event.target.closest('[data-room-tab]'));
        if (index < 0) return;
        let next;
        if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = this.tabs.length - 1;
        else if (event.key === (this.mobile.matches ? 'ArrowRight' : 'ArrowDown')) next = (index + 1) % this.tabs.length;
        else if (event.key === (this.mobile.matches ? 'ArrowLeft' : 'ArrowUp')) next = (index - 1 + this.tabs.length) % this.tabs.length;
        else return;
        event.preventDefault();
        this.select(next, true);
      };
      this.onBlockSelect = event => {
        const tab = event.target.closest('[data-room-tab]');
        if (tab && this.contains(tab)) this.select(this.tabs.indexOf(tab), false, true);
      };
      this.addEventListener('click', this.onClick);
      this.addEventListener('keydown', this.onKeydown);
      this.addEventListener('shopify:block:select', this.onBlockSelect);
      this.mobile.addEventListener('change', this.onOrientation);
      this.onOrientation();
      this.select(Math.max(0, this.tabs.findIndex(tab => tab.getAttribute('aria-selected') === 'true')));
    }

    select(index, focus = false, reveal = false) {
      if (index < 0 || index >= this.tabs.length) return;
      this.tabs.forEach((tab, i) => {
        const active = i === index;
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
        this.panels[i].hidden = !active;
      });
      this.panels[index].querySelectorAll('img').forEach(image => { image.loading = 'eager'; });
      if (focus) this.tabs[index].focus({ preventScroll: true });
      if (focus || reveal) {
        const tab = this.tabs[index];
        if (this.mobile.matches) this.tablist.scrollLeft = tab.offsetLeft - (this.tablist.clientWidth - tab.offsetWidth) / 2;
        else this.tablist.scrollTop = tab.offsetTop - (this.tablist.clientHeight - tab.offsetHeight) / 2;
      }
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('keydown', this.onKeydown);
      this.removeEventListener('shopify:block:select', this.onBlockSelect);
      this.mobile?.removeEventListener('change', this.onOrientation);
    }
  });
}
